import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, BookOpen } from 'lucide-react';

function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F5F0]">
      {/* Header */}
      <header className="bg-white border-b border-[#E0D8CC]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center space-x-3">
            <Button
              onClick={() => navigate(-1)}
              variant="ghost"
              className="text-[#2A2420]"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-[#2A2420] rounded-lg flex items-center justify-center">
                <BookOpen className="w-4 h-4 text-white" />
              </div>
              <span className="font-semibold text-[#2A2420]">The Storyteller</span>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#E0D8CC]">
          <h1 className="text-3xl font-serif font-bold text-[#2A2420] mb-2">Privacy Policy</h1>
          <p className="text-gray-500 mb-8">Last updated: February 2025</p>

          <div className="prose prose-gray max-w-none">
            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">1. Information We Collect</h2>
            <p className="text-gray-700 mb-4">
              We collect information you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Account information (name, email address) when you sign in with Google</li>
              <li>Content you create (books, chapters, notes)</li>
              <li>Usage data (features used, time spent writing)</li>
              <li>Feedback you submit through our feedback system</li>
            </ul>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Process your writing through AI tools to help you create better content</li>
              <li>Send you updates about your writing progress (if enabled)</li>
              <li>Respond to your feedback and support requests</li>
              <li>Monitor and analyze trends and usage</li>
            </ul>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">3. AI Processing</h2>
            <p className="text-gray-700 mb-4">
              When you use our AI features (Interview Mode, Polish, etc.), your content is processed by 
              AI services to provide writing assistance. Your stories remain yours - we don't use your 
              content to train AI models or share it with third parties.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">4. Data Storage</h2>
            <p className="text-gray-700 mb-4">
              Your content is stored securely in our databases. We use industry-standard security 
              measures to protect your information. You can delete your account and all associated 
              data at any time from the Settings page.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">5. Sharing</h2>
            <p className="text-gray-700 mb-4">
              We don't sell your personal information. We may share information with:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Service providers who assist in operating our platform</li>
              <li>Collaborators you explicitly invite to your books</li>
              <li>When required by law</li>
            </ul>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">6. Your Rights</h2>
            <p className="text-gray-700 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Access your personal data</li>
              <li>Export your books and content</li>
              <li>Delete your account and all data</li>
              <li>Opt out of marketing emails</li>
            </ul>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">7. Contact Us</h2>
            <p className="text-gray-700 mb-4">
              If you have questions about this Privacy Policy, please contact us through the feedback 
              button in the app.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default PrivacyPolicyPage;
